/**
 * Is the viewport a phone?
 *
 * One definition of "mobile" for the whole app, so a component that
 * hides something at this width and a component that changes behaviour
 * at it cannot disagree by a pixel. 767.98px is the same line
 * layout.css, the dashboards and the chat all break at.
 *
 * It lived in Trainer/ui/RowSheet, which was fine while the sheet was
 * its only caller. It is now read by the student dashboard and by the
 * notification bell in the global header, and a header importing from
 * a trainer folder is a dependency nobody means to take. RowSheet
 * re-exports it, so every existing import still resolves.
 */

import { useEffect, useState } from 'react';

const MOBILE = '(max-width: 767.98px)';

const supportsMatchMedia = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function';

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(
    () => supportsMatchMedia() && window.matchMedia(MOBILE).matches,
  );

  useEffect(() => {
    if (!supportsMatchMedia()) return undefined;
    const mq = window.matchMedia(MOBILE);
    const onChange = (e) => setIsMobile(e.matches);
    // addListener is the Safari < 14 spelling; addEventListener everywhere else.
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', onChange);
      else mq.removeListener(onChange);
    };
  }, []);

  return isMobile;
};

export default useIsMobile;
